/**
 * Plataforma da telemetria — separada do collector (17/09) para o
 * `affiliate_click` carregá-la nas props sem puxar `firebase/auth` e o
 * `db` junto. Pura fora do `window`; o BUG-64 vive no `isNativeApp`.
 */

import { isNativeApp } from "./platform/native";

export type TelemetryPlatform = "web" | "pwa" | "capacitor";

/**
 * Exportado desde 17/09 para o `affiliate_click` carregar a plataforma nas
 * props: o heartbeat de sessão já sabia, o evento não, e 64 % das sessões são
 * `capacitor` — sem isto não dá para separar clique da web de clique do app.
 */
export function detectPlatform(): TelemetryPlatform {
  try {
    // BUG-64: `"Capacitor" in window` NÃO responde "é app nativo" — o
    // `@capacitor/core` cria a global no import, então todo usuário web que
    // passasse pela busca (onde o módulo é importado) era contado como
    // `capacitor`. Ver o comentário longo em `lib/installPrompt.ts`.
    if (isNativeApp()) return "capacitor";
    if (window.matchMedia?.("(display-mode: standalone)").matches) return "pwa";
  } catch {
    /* SSR/old browsers */
  }
  return "web";
}
